module.exports = __webpack_public_path__ + "static/media/bg-fat-analysis.d67079dc.png";